<template>
  <!-- Visual Analysis wrapper of BB-annotating component -->
  <bb-annotating
    type="analysing"
    intro="Start creating your Visual Analysis block by adding a "
    v-on="$listeners"
    v-bind="$props"
  />
</template>

<script>
import BbAnnotating from './BB-annotating';

export default {
  name: "BBAnalysing",

  components:{
    BbAnnotating
  },

  props:{
    blockId: {
      type: String,
      default: ''
    },
    mode: {
      type: String,
      default: 'student'
    },
    view: {
      type: String,
      default: 'view'
    },
    editor: {
      type: Boolean,
      default:false
    },
    showInstructions: {
      type: Boolean,
      default: false
    }
  },

  mounted () {
    console.log('mount BB-analysing');
  }
}
</script>